import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDebouncedEffect } from "../../../lib/useDebounceEffect";
import styles from "./index.module.css";

function DebounceInput({
  placeholder,
  onchange,
  value,
  name,
  label,
  mb0 = false,
  type = "text",
  full = false,
  required = false,
  helperText,
  min = 1,

  emptyField = [],
  delay = 500, // Default debounce delay in milliseconds
  showDebounceIndicator = false, // Show loading indicator while debouncing
}) {
  const [inputValue, setInputValue] = useState(value || "");
  const [isDebouncing, setIsDebouncing] = useState(false);
  const isFirstRun = useRef(true);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useDebouncedEffect(
    () => {
      if (!isFirstRun.current) {
        onchange({
          target: {
            name: name,
            value: inputValue,
          },
        });
      } else {
        isFirstRun.current = false;
      }

      setIsDebouncing(false);
    },
    delay,
    [inputValue]
  );

  const handleInputChange = useCallback((e) => {
    setIsDebouncing(true);
    setInputValue(e.target.value);
  }, []);
  return (
    <div className={`form-group ${mb0 ? "mb-0" : "mb-3"}`}>
      {label && (
        <label className="form-label" htmlFor="exampleFormControlInput1">
          {label} {required ? <span className="text-danger">*</span> : ""}
        </label>
      )}
      <div className="position-relative">
        <input
          className={`form-control ${styles.debounceInput}${emptyField.includes(name) ? "is-invalid" : ""
            }`}
          type={type}
          min={min}
          placeholder={placeholder}
          onChange={handleInputChange}
          name={name}
          value={inputValue}
        />
        {showDebounceIndicator && isDebouncing && (
          <div
            className="position-absolute top-50 end-0 translate-middle-y me-2"
            style={{ pointerEvents: "none" }}
          >
            <div
              className="spinner-border spinner-border-sm text-muted"
              role="status"
              style={{ width: "16px", height: "16px" }}
            >
              <span className="visually-hidden">Searching...</span>
            </div>
          </div>
        )}
      </div>
      {helperText && (
        <p className="text-muted mt-2" style={{ fontSize: 12 }}>
          {helperText}
        </p>
      )}
    </div>
  );
}

export default DebounceInput;
